module.exports = __webpack_public_path__ + "static/media/ios-alarm.e66a15bb.svg";